import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import SChip from '@/components/SChip.vue';
import { getMonitorStatusDefinition } from '@/modules/monitors/helpers/monitor-helpers';
import { RunStatusValues, type RunStatusTypes } from '@/modules/monitors/@types/monitor-types';

interface RunStatusProps {
  status?: RunStatusTypes;
  plain?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RunStatus',
  props: {
  status: null,
  plain: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const isRunning = _computed(() => props.status === RunStatusValues.RUNNING);
const hasRunStatus = _computed(() => props.status);
const statusDefinition = _computed(() => getMonitorStatusDefinition(props.status));


return { __sfc: true,props, isRunning, hasRunStatus, statusDefinition, _computed, SChip, getMonitorStatusDefinition, RunStatusValues }
}

})